import { randomUUID } from 'uncrypto';

export function useSession() {
  const sessionId = useState('session_id', () => randomUUID());

  return { sessionId: readonly(sessionId) };
}